import React from 'react'
import { isDefinedAndNotEmpty } from '@/utils/isDefined'
import classnames from 'classnames'

export function filterCell (Elm, props) {
  return React.cloneElement(Elm, { ...Elm.props, className: classnames(Elm.props.className, isDefinedAndNotEmpty(props.value) ? 'k-filtercell-filtered' : '') }, Elm.props.children)
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/BsrsGrid.GridFilterCell.js